module.exports = __webpack_public_path__ + "static/media/matnrrd_2-360w.ba55ca5c.png";